import { z } from "zod";
export const RawDataPageMetaData = z.object({
    plants: z.array(z.object({
        id: z.number(),
        name: z.string(),
    })),
    sensorDefinitions: z.array(z.object({
        id: z.number(),
        name: z.string(),
    })),
});
//# sourceMappingURL=dbPageRawData.js.map